import { useState, useEffect, useCallback } from 'react'

// Generic async-load hook: { data, loading, error, reload }.
// Shared by every Product Knowledge view so loading/error/empty states
// are handled identically everywhere in this module.
export function useAsyncData(loader, deps) {
  const [state, setState] = useState({ data: null, loading: true, error: null })

  const load = useCallback(() => {
    let cancelled = false
    setState(s => ({ ...s, loading: true, error: null }))
    loader()
      .then(data => { if (!cancelled) setState({ data, loading: false, error: null }) })
      .catch(error => { if (!cancelled) setState({ data: null, loading: false, error }) })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  useEffect(() => load(), [load])

  return { ...state, reload: load }
}
